// src/components/ViewPage.jsx
import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import styles from './ViewPage.module.css';
import { API } from '../config';
import SidebarTree from './SidebarTree';

const ViewPage = () => {
  const { id } = useParams();
  const [pageTree, setPageTree] = useState([]);
  const [selectedPage, setSelectedPage] = useState(null);
  const [sidebarVisible, setSidebarVisible] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    if (id) {
      fetchPageTree(id);
      fetchPageById(id);
    }
  }, [id]);

  const fetchPageTree = async (rootId) => {
    try {
      const res = await fetch(`${API.GET_PAGE_TREE_BY_ROOT}?page_id=${rootId}`);
      const data = await res.json();
      if (data.success) {
        setPageTree([data.tree]); // wrapped in array for SidebarTree
      }
    } catch (err) {
      console.error("Failed to load tree", err);
    }
  };

  const fetchPageById = async (pageId) => {
    try {
      const res = await fetch(`${API.GET_PAGE_BY_ID}?page_id=${pageId}`);
      const data = await res.json();
      if (data.success) {
        setSelectedPage(data.page);
      }
    } catch (err) {
      console.error("Failed to fetch page", err);
    }
  };

  const handleDeletePage = async (deleteId) => {
  if (!window.confirm("Are you sure you want to delete this page?")) return;

  try {
    const res = await fetch(`${API.DELETE_PAGE}?id=${deleteId}`, {
      method: 'DELETE',
    });

    const data = await res.json();

    if (data.success) {
      alert("Page deleted!");
      navigate('/pagelist'); // ✅ Redirect to page list after deletion
    } else {
      alert(data.message || "Failed to delete");
    }
  } catch (err) {
    console.error("Delete error:", err);
    alert("Server error while deleting.");
  }
};

  return (
    <div className={styles.viewPage}>
      {/* Collapse/Show button */}
      <button
        className={styles.toggleBtn}
        onClick={() => setSidebarVisible(!sidebarVisible)}
      >
        {sidebarVisible ? '☰ Hide' : '☰ Show'}
      </button>

      <aside className={sidebarVisible ? styles.sidebar : styles.sidebarCollapsed}>
        <SidebarTree
          pages={pageTree}
          onSelect={(selectedId) => fetchPageById(selectedId)}
          onDelete={handleDeletePage}
        />
      </aside>

      <main className={styles.content}>
        {selectedPage ? (
          <>
            <h2>{selectedPage.title}</h2>
            {selectedPage.content_json &&
              JSON.parse(selectedPage.content_json).map((block, i) => {
                switch (block.type) {
                 case 'heading': {
  const Tag = block.level || 'h2'; // defaults to h2 if not set
  return React.createElement(Tag, { key: i }, block.content);
}

              case 'paragraph':
  return (
    <div
      key={i}
      dangerouslySetInnerHTML={{ __html: block.content }}
    />
  );

                  case 'list':
                    return (
                      <ul key={i}>
  {block.items.map((item, j) => (
    <li key={j} dangerouslySetInnerHTML={{ __html: item }} />
  ))}
</ul>

                    );
                 case 'table':
  return (
    <table key={i} border="1">
      <tbody>
        {block.rows.map((row, r) => (
          <tr key={r}>
            {row.map((cell, c) => (
              <td key={c} dangerouslySetInnerHTML={{ __html: cell }} />
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
   case 'image':
                return (
                  <div key={i}>
                    {block.url ? (
                      <img
                        src={block.url}
                        alt={block.alt || 'Uploaded Image'}
                        style={{ maxWidth: '100%', height: 'auto' }}
                      />
                    ) : (
                      <p>No image</p>
                    )}
                  </div>
                );
     case 'youtube': {
  const videoIdMatch = block.url?.match(
    /(?:youtube\.com\/(?:[^\/]+\/.+|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?\/\s]{11})/
  );
  const videoId = videoIdMatch ? videoIdMatch[1] : null;

  return videoId ? (
    <div key={i} style={{ margin: '20px 0', textAlign: 'center' }}>
      <iframe
        width="70%"
        height="400"
        src={`https://www.youtube.com/embed/${videoId}`}
        title="YouTube Video"
        frameBorder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
      ></iframe>
    </div>
  ) : (
    <p key={i} style={{ color: 'red' }}>Invalid YouTube URL</p>
  );
}

                  case 'code':
                    return (
                      <pre key={i}>
                        <code>{block.content}</code>
                      </pre>
                    );
                  default:
                    return null;
                }
              })}
          </>
        ) : (
          <p>Loading page...</p>
        )}
      </main>
    </div>
  );
};

export default ViewPage;
